<template lang="html">
<div class="view-transactions-detail" v-loading="loading">
  <row>
    <div class="sl-col-4">
      <div class="sl-form" style="max-width: 700px;margin: 16px auto;">
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="24">
            <div>
              <h3 class="trx-title">{{form.trxId}}</h3> </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="24">
            <div>
              <h3>{{$t('Views.TrxViewDeital.table.t1')}}</h3> </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;" class="border-line sl-trx-val">
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.trxId')}}:</strong>
              <span>{{form.trxId}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div> <strong>{{$t('Views.TrxViewDeital.table.createTime')}}:</strong>
              <span>{{form.createTime}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div> <strong>{{$t('Views.TrxViewDeital.table.createLocalTime')}}:</strong>
              <span>{{localTime}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.customer')}}:</strong>
              <span>{{form.customer}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.payChannel')}}:</strong>
              <span>{{form.payType}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.payTrxId')}}:</strong>
              <span>{{form.businessId}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.posId')}}:</strong>
              <span>{{form.sn}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.cashier')}}:</strong>
              <span>{{form.username}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.customer')}}:</strong>
              <span>{{form.username}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div class="sl-remark" v-if="!editRemark">
              <strong>{{$t('Views.TrxViewDeital.table.remark')}}:</strong>
              <span style="position:relative;cursor:pointer;" @click="editRemark = true;remarkCnt=form.remark;remarkNumber = 200 - form.remark.length">
                <p>{{form.remark}}</p><i></i>
              </span>
            </div>
            <div v-else class="sl-remark-edit">
              <strong>{{$t('Views.TrxViewDeital.table.remark')}}:</strong>
              <div>
                <el-input :maxlength="200" type="textarea" :autosize="{ minRows: 1, maxRows: 5}" placeholder="remark" v-model="remarkCnt" @change="handleRemarkChange"></el-input>
                <span class="sl-remark-number">{{remarkNumber}}</span>
                <div class="sl-remark-action">
                  <el-button size="mini" @click="editRemark = false">{{$t('Functional.cancel')}}</el-button>
                  <el-button size="mini" type="success" @click="saveRemark" :loading="saveRemarkLoading">{{$t('Functional.save')}}</el-button>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20" style="margin-bottom: 10px" class="border-line sl-trx-val">
            <el-col :span="12" :xs="24" :class="{'sl-no-coupon': form.disAmount === '0.00' || form.disAmount === '' }">
              <img src="../../assets/imgs/line_01.png" class="sl-line-01">
              <div class="sl-trx-mainval">
                <strong>{{$t('Views.TrxViewDeital.table.realAmount')}}:</strong>
                <span><b>{{currency}}</b>{{form.realAmount}}</span>
              </div>
              <div class="sl-trx-subval">
                <img src="../../assets/imgs/line_02.png" alt="">
                <strong>{{$t('Views.TrxViewDeital.table.customerAmount')}}:</strong>
                <span><b>{{currency}}</b>{{form.initAmount}}</span>
              </div>
              <div class="sl-trx-subval sl-trx-discount">
                <img src="../../assets/imgs/line_02.png" alt="">
                <strong>{{$t('Views.TrxViewDeital.table.discount')}}:</strong>
                <span><b>{{currency}}</b>-{{form.disAmount}}</span>
              </div>
              <div class="sl-trx-subval">
                <img src="../../assets/imgs/line_02.png" alt="">
                <strong>{{$t('Views.TrxViewDeital.table.fee')}}:</strong>
                <span><b>{{currency}}</b>{{form.serviceFee}}</span>
              </div>
            </el-col>
            <el-col :span="12" :xs="24">
              <div>
                <strong>{{$t('Views.TrxViewDeital.table.cRate')}}:</strong>
                <span>{{(form.cRate * 100).toFixed(2)}}%</span>
              </div>
              <div>
                <strong>{{$t('Views.TrxViewDeital.table.mRate')}}:</strong>
                <span>{{(form.merchantFeeRate * 100).toFixed(2)}}%</span>
              </div>
              <div>
                <strong>{{$t('Views.TrxViewDeital.table.settleAmount')}}:</strong>
                <span><b>{{currency}}</b>{{form.settleAmount}}</span>
              </div>
            </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;">
          <el-col :span="24">
            <div>
              <h3>{{ transferName }}</h3> </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;" class="border-line sl-trx-val">
          <el-col :span="24">
            <div> <strong>{{$t('Views.TrxViewDeital.table.settleTime')}}:</strong>
              <span>{{form.settleTime}}</span>
            </div>
          </el-col>
        </el-row>
        <template v-if="form.refundList.length !== 0">
          <template v-for="(item,index) in form.refundList">
            <el-row :gutter="20" class="sl-trx-val" >
              <el-col :span="24">
                <div>
                  <h3>{{$t('Views.TrxViewDeital.table.refundRecord')}}</h3>
                </div>
              </el-col>
              <el-col :span="24">
                <div>
                  <strong>{{$t('Views.TrxViewDeital.table.refundStatus')}}:</strong>
                  <span v-show="item.status === '10'">{{$t('Views.TrxViewDeital.table.requestForRefund')}}</span>
                  <span v-show="item.status === '11'">{{$t('Views.TrxViewDeital.table.refunded')}}</span>
                  <span v-show="item.status === '12'">{{$t('Views.TrxViewDeital.table.refundFailed')}}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div>
                  <strong>{{$t('Views.TrxViewDeital.table.appTime')}}:</strong>
                  <span>{{item.createTime}}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div>
                  <strong>{{$t('Views.TrxViewDeital.table.completeTime')}}:</strong>
                  <span>{{item.modifyTime}}</span>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20" style="margin-bottom: 10px;" :class="{'border-inline': index + 1 !== form.refundList.length }" class="sl-trx-val">
              <el-col :span="24">
                <div>
                  <strong>{{$t('Views.TrxViewDeital.table.refundAmount')}}:</strong>
                  <span><b>{{currency}}</b>{{item.refundAmount}}</span>
                </div>
              </el-col>
            </el-row>
          </template>
        </template>
        <el-row :gutter="20" style="margin-bottom: 10px;" :class="{'border-top': form.refundList.length !== 0 }">
          <el-col :span="24">
            <div>
              <h3>{{$t('Views.TrxViewDeital.table.refund')}}</h3> </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-bottom: 10px;" class="sl-trx-val">
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.refundAbleAmount')}}:</strong>
              <span><b>{{currency}}</b>{{form.refundAmount}}</span>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.refundAmount')}}:</strong>
              <el-input type="number" @focus="type = 'text'" @blur="type = 'password'" class="sl-fr sl-val-input" v-model="amount" :disabled="show" :class="{'disabled': show}" step="0.01" auto-complete="off" min="0">
              </el-input>
              <b class="sl-fr">{{currency}}</b>
              <el-checkbox v-model="checked" :disabled="allDistable" class="sl-fr sl-checkbox" >{{$tc('Functional.all',0)}}</el-checkbox>
            </div>
          </el-col>
          <el-col :span="24">
            <div>
              <strong>{{$t('Views.TrxViewDeital.table.finalAmount')}}:</strong>
              <span class="final-amount"><b>{{currency}}</b>{{finalAmount}}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" style="text-align:center;">
            <router-link tag="el-button" :to="{ name: 'Transactions' }" @click.native="$ga.event('Link', 'Back', 'View transaction detail')">{{$t('Functional.back')}}</router-link>
            <el-button @click.native="dialogVisible = true;$ga.event('Button', 'Refund', 'View transaction detail')" :disabled="refundShow" v-show="form.amount !== 0">{{$t('Button.refund')}}</el-button>
          </el-col>
        </el-row>

      </div>
    </div>
  </row>

  <el-dialog :title="$t('Views.TrxViewDeital.tips.title')" v-model="dialogVisible" size="tiny">
    <span>{{$t('Views.TrxViewDeital.tips.cnt')}}</span>
    <span slot="footer" class="dialog-footer">
      <el-input :type="type" v-model="refundPwd" :placeholder="$t('Views.TrxViewDeital.tips.placeholder')" class="refund-pwd" auto-complete="off"></el-input>
      <el-button @click="dialogVisible = false">{{$t('Functional.cancel')}}</el-button>
      <el-button type="success" @click="refund">{{$t('Functional.confirm')}}</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import api from '../../api'
import moment from 'moment'
export default {
  name: 'view-transactions',
  created() {
    const vm = this
    api.FetchTrxById(this.$route.params.id).then(res => {
      if (res.data.code === 200) {
        vm.form = res.data.data
        vm.form.settleTime = vm.form.settleTime === '0' ? '-' : moment(vm.form.settleTime * 1000).format('LT')
        vm.transferNameList.map(item => {
          if (item.name === vm.form.settleStatus) {
            vm.transferName = item.value
          }
        })
      }
      vm.loading = false
    })
  },
  computed: {
    allDistable() {
      if (+this.form.refundAmount === 0) {
        return true
      }
      return false
    },
    localTime() {
      // return moment(this.form.createTimeStamp * 1000).utcOffset(this.$store.state.theme.companyInfo.utcOffset).format('LT')
      return moment.tz(this.form.createTimeStamp * 1000, 'Asia/shanghai').clone().tz(this.$store.state.theme.companyInfo.timeZone).format('LT')
    }
  },
  data() {
    return {
      loading: true,
      saveRemarkLoading: false,
      show: false,
      refundShow: true,
      amount: 0,
      checked: false,
      form: {
        refundList: []
      },
      transferName: '',
      transferNameList: [
        {
          name: '1',
          value: this.$tc('Views.TrxViewDeital.transferNameList', 1)
        },
        {
          name: '2',
          value: this.$tc('Views.TrxViewDeital.transferNameList', 2)
        },
        {
          name: '3',
          value: this.$tc('Views.TrxViewDeital.transferNameList', 3)
        }],
      finalAmount: 0,
      refundPwd: '',
      dialogVisible: false,
      currency: this.$store.state.theme.companyInfo.currency,
      type: 'password',
      editRemark: false,
      remarkCnt: '',
      remarkNumber: 200
    }
  },
  watch: {
    amount() {
      checkAmount(this)
    },
    checked() {
      if (this.checked === true) {
        this.finalAmount = this.form.refundAmount
        this.amount = (this.finalAmount / (1 + (+this.form.cRate))).toFixed(2)
        this.show = true
        this.refundShow = false
      } else {
        checkAmount(this)
        this.show = false
      }
    }
  },
  methods: {
    handleRemarkChange(val) {
      this.remarkNumber = 200 - val.length
    },
    saveRemark() {
      this.$ga.event('Button', 'Remark', 'View transaction detail')
      this.saveRemarkLoading = true
      const vm = this
      api.changeRemark(this.form.trxId, {
        remark: this.remarkCnt
      }).then(res => {
        if (res.data.code === 200) {
          vm.form.remark = vm.remarkCnt
        } else {
          vm.errorMsg(res)
        }
        vm.editRemark = vm.saveRemarkLoading = false
      }).catch(error => {
        vm.editRemark = vm.saveRemarkLoading = false
        vm.errorMsg(error)
      })
    },
    refund() {
      const vm = this
      this.$loading()
      api.RefundTrxAmount(this.form.trxId, {
        amount: this.finalAmount,
        password: this.refundPwd
      }).then(res => {
        if (res.data.code === 200) {
          vm.successMsg(res)
          vm.$router.push({
            path: '/trx'
          })
        } else {
          vm.dialogVisible = false
          vm.errorMsg(res)
        }
        this.$loading().close()
      })
    },
    successMsg(res) {
      this.$notify.success({
        title: this.$t('Notify.suc'),
        message: res.data.msg
      })
    },
    errorMsg(res) {
      this.$notify.error({
        title: this.$t('Notify.err'),
        message: res.data.msg
      })
    }
  }
}

function checkAmount(vm) {
  if (vm.checked === false) {
    vm.finalAmount = (vm.amount * (1 + Number.parseFloat(vm.form.cRate))).toFixed(2)
    if (vm.finalAmount > 0 && vm.finalAmount <= vm.form.refundAmount) {
      vm.refundShow = false
    } else {
      vm.refundShow = true
    }
  } else {
    vm.finalAmount = vm.form.refundAmount
    vm.refundShow = false
  }
}
</script>
<style scoped>
.trx-title {
  text-align: center;
  padding-bottom: 15px;
  border-bottom: 1px solid #d7d7d7;
}

.sl-fr {
  float: right;
}

.border-line {
  border-bottom: 1px solid #d7d7d7 !important;
  padding-bottom: 20px;
}

.border-inline {
  border-bottom: 1px dashed #d7d7d7 !important;
  padding-bottom: 10px;
}

.border-top {
  padding-top: 10px;
  border-top: 1px solid #d7d7d7;
}

.disabled {
  background-color: #d7d7d7;
}

.refund-pwd.el-input {
  top: -20px;
}

.view-transactions-detail strong {
  font-family: Avenir-Book;
  font-size: 13px;
  color: #848484;
  line-height: 32px;
}

.sl-trx-val span {
  float: right;
  font-family: Avenir-Book;
  font-size: 13px;
  color: #000000;
  line-height: 32px;
}

.sl-trx-val span b,
b.sl-fr {
  font-family: Avenir-Book;
  font-size: 12px;
  color: #848484;
  line-height: 32px;
  padding-right: 4px;
}

.view-transactions-detail .sl-checkbox {
  margin: 5px 80px 0 0;
  font-family: Avenir-Book;
  font-size: 13px;
  color: #4A4A4A;
  font-weight: normal;
}

@media screen and (max-width:768px) {
  .view-transactions-detail .sl-checkbox {
    margin-right: 20px;
  }
}

.view-transactions-detail .final-amount {
  font-family: Avenir-Medium;
  font-size: 19px;
  color: #000000;
  line-height: 26px;
}

.view-transactions-detail .sl-val-input {
  text-align: right;
}

.view-transactions-detail h3 {
  font-family: Avenir-Medium;
  font-size: 16px;
  color: #4A4A4A;
}

img.sl-line-01 {
  position: absolute;
  width: 5px;
  height: 99px;
  top: 13px;
}

.sl-trx-mainval {
  width: calc(100% - 10px);
  float: right;
}

.sl-trx-subval img {
  height: 3px;
}

.sl-trx-subval {
  float: right;
  width: calc(100% - 5px)
}

.sl-trx-discount span {
  color: #D61010;
}

.sl-no-coupon .sl-trx-discount {
  display: none;
}

.sl-no-coupon img.sl-line-01 {
  height: 69px;
}

.sl-remark:hover i {
  background-image: url('/static/imgs/edit_active.png');
  cursor: pointer;
}

.sl-remark:hover span p {
  text-decoration: underline;
}

.sl-remark i {
  width: 16px;
  height: 16px;
  background-image: url('/static/imgs/edit_default.png');
  background-size: 16px 16px;
  display: inline-block;
  position: absolute;
  top: 8px;
  right: 0;
}

.sl-remark-edit .el-textarea {
  max-width: 500px;
}

.sl-remark-edit>div {
  float: right;
  width: 400px;
}

@media only screen and (max-width: 768px) {
  div.sl-remark-edit>div {
    width: 100%;
  }
  div.sl-remark>span {
    max-width: 100%;
  }
  div.sl-remark>span p {
    width: calc(100% - 20px);
  }
}

.sl-remark-action {
  float: right;
  margin-top: 10px;
}

.sl-remark-number {
  position: absolute;
  color: #c7c7c7 !important;
}

.sl-remark>span {
  max-width: 500px;
  height: 32px;
  overflow: hidden;
  display: inline-block;
}

.sl-remark>span p {
  max-width: 470px;
  margin-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
<style>
.view-transactions-detail .sl-val-input {
  border-radius: 0;
  width: 150px;
}

@media screen and (max-width:768px) {
  .view-transactions-detail .sl-val-input {
    border-radius: 0;
    width: 100px;
  }
}

.view-transactions-detail .sl-val-input .el-input__inner {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// view-detail.vue?7be424cd